module.exports = __webpack_public_path__ + "img/category-brand.c68c04c5.png";